import Character from "./Character";

export default Character